import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import CheckCircle from '@mui/icons-material/CheckCircle';
import Edit from '@mui/icons-material/Edit';
import Image from '@mui/icons-material/Image';
import CreditScore from '@mui/icons-material/CreditScore';
import Paid from '@mui/icons-material/Paid';
import PriceCheck from '@mui/icons-material/PriceCheck';
import VolunteerActivism from '@mui/icons-material/VolunteerActivism';

export const ItemsListHeader = ({ items, selectedItems, onSelectAll }) => {
    const handleSelectAllChange = (e) => {
        onSelectAll(e);
    };

    return (
        <Grid container spacing={ 1 } sx={ { width: '100%', display: 'flex', mb: 1, p: 1 } }>
            <Grid sx={ { px: 0, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ 1 } display='flex' justifyContent='center' alignItems='center'>
                <Tooltip title="Select All">
                    <Checkbox
                        checked={ selectedItems.length === items.length && items.length > 0 }
                        onChange={ handleSelectAllChange }
                        indeterminate={ selectedItems.length > 0 && selectedItems.length < items.length }
                        disabled={ items.length === 0 }
                    />
                </Tooltip>
            </Grid>

            <Grid sx={ { p: 1, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ { xs: 4, sm: 2 } } display='flex' alignItems='center'>
                <Typography variant="title" noWrap>Name</Typography>
            </Grid>

            <Grid sx={ { p: 1, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ 2 } display={ { xs: 'none', sm: 'flex' } } alignItems='center'>
                <Typography variant="title" noWrap>Price</Typography>
            </Grid>

            <Grid sx={ { p: 1, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ 1 } display='flex' justifyContent='center' alignItems='center'>
                <Tooltip title="Item Sold">
                    <Paid sx={ { fontSize: { xs: 16, sm: 24 } } } />
                </Tooltip>
            </Grid>

            <Grid sx={ { p: 1, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ 1 } display='flex' justifyContent='center' alignItems='center'>
                <Tooltip title="Item Has Image">
                    <Image sx={ { fontSize: { xs: 16, sm: 24 } } } />
                </Tooltip>
            </Grid>

            <Grid sx={ { p: 1, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ 1 } display='flex' justifyContent='center' alignItems='center'>
                <Tooltip title="Donated Item">
                    <VolunteerActivism sx={ { fontSize: { xs: 16, sm: 24 } } } />
                </Tooltip>
            </Grid>

            <Grid sx={ { p: 0, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ 1 } display='flex' justifyContent='center' alignItems='center'>
                <Tooltip title="Seller Paid">
                    <PriceCheck sx={ { fontSize: { xs: 16, sm: 24 } } } />
                </Tooltip>
            </Grid>

            <Grid sx={ { p: 0, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ 1 } display='flex' justifyContent='center' alignItems='center'>
                <Tooltip title="Listing Fees Paid" >
                    <CreditScore sx={ { fontSize: { xs: 16, sm: 24 } } } />
                </Tooltip>
            </Grid>

            <Grid sx={ { p: 0, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ 1 } display='flex' justifyContent='center' alignItems='center'>
                <Tooltip title="Verified">
                    <CheckCircle sx={ { fontSize: { xs: 16, sm: 24 } } } />
                </Tooltip>
            </Grid>

            <Grid sx={ { p: 0, backgroundColor: 'grey.700', borderRadius: '4px' } } size={ 1 } display='flex' justifyContent='center' alignItems='center'>
                <Tooltip title="Edit Item">
                    <Edit sx={ { fontSize: { xs: 16, sm: 24 } } } />
                </Tooltip>
            </Grid>
        </Grid>
    );
};